module.exports = __webpack_public_path__ + "img/connect-bg.382e793d.svg";